/* NODE PACKAGES */
import React from'react';

const Main: React.FC<{children?: React.ReactNode}> = (props) =>
  {
  return <main className="d-print-none d-block m-0 p-0">{props.children}</main>
  }

export default Main;
